import { CheckSimpleIcon, InvalidIcon } from "@ui/components/Icon";
import type { ValidationState } from "@ui/components/shared/resolveValidationState";

export interface ValidationIconProps {
  state: ValidationState;
  /** The consumer's `validationIcon` slot classes. */
  className?: string;
}

/** The aria-hidden InvalidIcon/CheckSimpleIcon pair shared by the field families. */
export function ValidationIcon({ state, className }: ValidationIconProps) {
  return (
    <span aria-hidden="true" className={className}>
      {state === "invalid" ? <InvalidIcon /> : <CheckSimpleIcon />}
    </span>
  );
}
